<mat-sidenav-container>
    <mat-sidenav #sidenav role="navigation">
        <app-sidenav (sidenavClose)="sidenav.close()"></app-sidenav>
    </mat-sidenav>
    <mat-sidenav-content fxFlexFill fxLayout="column" appScrollScreenDirective>
        <app-header (sidenavToggle)="sidenav.toggle()"></app-header>
        <main fxFlex>
            <router-outlet></router-outlet>
        </main>
        <app-footer></app-footer>
    </mat-sidenav-content>
</mat-sidenav-container>
